import { render, staticRenderFns } from "./learning-time.vue?vue&type=template&id=467f50be&scoped=true"
import script from "./learning-time.vue?vue&type=script&lang=js"
export * from "./learning-time.vue?vue&type=script&lang=js"
import style0 from "./learning-time.vue?vue&type=style&index=0&id=467f50be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f50be",
  null
  
)

export default component.exports